<template>
	<m-layout class="driver">
    <m-trips-list :trips="tripsList" :dialog="dialog_trips" @close="dialog_trips=false" @show="onShowTrip"></m-trips-list>
    <div fill-height class="fill-height" style="height:100%; width:100%">
      <v-layout wrap grid-list-md style="height: 100%;">
        <google-map ref="gmap" name="gmap" :poi="poi" :driversCoord="locations" @refresh="clearLocations"></google-map>
      </v-layout>
    </div>
	</m-layout>
</template>
<script>
import { refLocations } from '@/services/firebase';
import Mgmap from '@/components/googlemaps/gmap';
import Driver from '@/components/driver/driver';
import TripsList from '@/components/driver/tripslist';

export default {
  components: {
    'm-trips-list': TripsList,
    'google-map': Mgmap
  },
  data () {
    return {
      dialog_trips: false,
      refLoc: refLocations,
      locations: [],
      map: null,
      mapEl: null,
      zdestinations: [],
      poi: [],
      tripsList: [],
      drivers: {}
    }
  },
  methods: {
    FCM_off (){
      this.refLoc.off();
    },
    FCM_on () {
      var app = this;

      this.refLoc.on('child_added', (snapshot) => {
        var map = app.$refs.gmap.map;
        let d = snapshot.val()
        let key = Object.keys(d)[0];
        app.drivers[key] = new Driver(key, d, map);
        app.drivers[key].addMarker(map);
      })
      this.refLoc.on('child_removed', (snapshot) => {
        let d = snapshot.val()
        let key = Object.keys(d)[0];
        this.drivers[key].removeMarker();
      })
      this.refLoc.on('child_changed', (snapshot) => {
        var d = snapshot.val();
        let key = Object.keys(d)[0];
        let data = Object.values(d)[0];
        console.log('child_changed', d);
        this.drivers[key].update(data);
      })
      this.refLoc.on('value', (snapshot) => {
          app.locations = [];
          snapshot.forEach(function (childSnapshot) {
            var driverLocation = childSnapshot.val();
            Object.keys(driverLocation).forEach(function (key) {
              if (driverLocation[key] && driverLocation[key].l) {
                app.locations.push(app.drivers[key]);
              }
            });
          });
        })
    },
    getLocations (itemId) {
      return new Promise((resolve) => {
        var app = this;
        ((itemId) ? this.refLoc.equalTo(Number(itemId)) : this.refLoc)
        .on('value', function (snapshot) {
          app.locations = [];
          snapshot.forEach(function (childSnapshot) {
            var driverLocation = childSnapshot.val();
            console.log('key', driverLocation);
            Object.keys(driverLocation).forEach(function (key) {

              if (driverLocation[key] && driverLocation[key].l) {
                var driver = new Driver(key, driverLocation);
                app.locations.push(driver);
              }
            });
            // console.log('location', location);
          });
          // console.log('getLocations', app.locations);
          resolve(app.locations);
        })
      });
    },
    clearLocations() {
      this.refLoc.remove().then(() => {
        console.log('cleared location');
      });
    },
    getData () {
      this.getLocations();
    },
    toggle () {
      this.$refs.gmap.toggleMarker(this.poi);
    },
    onRefresh () {
      this.getData();
    },
    onShowTrip(item) {
      var driverKey = item.driver.id + '_' + item.driver.name;
      var driver = this.drivers[driverKey];
      var waypts = [
        {location: driver.pos.latitude + ',' + driver.pos.longitude}
      ]
      var data = {
        origin: item.client.pos.latitude + ',' + item.client.pos.longitude,
        destination: item.destination.pos.latitude + ',' + item.destination.pos.longitude,
        waypoints: waypts
      }
      console.log('showTrip: ', data);

      this.$refs.gmap.showRoute(data);

    },
    driverTrips (trips) {
      this.tripsList = trips;
      console.log('show driverTrips', trips);
      this.dialog_trips = true;
    }
  },
  created () {
    // this.getData();
    this.FCM_on();
    this.$bus.$on('driverTrips', this.driverTrips);
  },
  beforeDestroy () {
    this.FCM_off();
    this.$bus.$off('driverTrips');
  },
};
</script>
<style lang="scss">
  .driver {
    .google-map {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      background: gray;
      z-index: 0;
    }
  }
  .drivers-overlay {
    position: absolute;
    top: 45px;
    z-index: 3;
    background: rgba(255,255, 255, 0.9);
    padding: 4px 6px;
    border: solid 1px grey;
    font-size: 14px;
    .drivers-item {
      cursor: pointer;
    }
  }

  .btn-socket-drivers {
    position: absolute;
    z-index: 2;
    top: initial;
    left: 15px;
    bottom: 15px;
  }
  .socket-drivers {
    top: initial;
    left: 15px;
    bottom: 15px;
  }
  .all-overlay {
    background: rgba(255,255, 255, 0.6);
    border: solid 1px grey;
  }
  .poi-overlay {
    position: absolute;
    z-index: 2;
    background: rgba(255,255, 255, 0.6);
    border: solid 1px grey;
    .btn {
      margin: 1px;
    }
    .poi-item {
      cursor: pointer;
    }
  }
</style>
